var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _vm.planned
            ? _c("filter-by-date", {
                attrs: { type: "date", small: "", namespace: _vm.namespace }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("interventions-filter", { attrs: { namespace: _vm.namespace } })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        directives: [
          {
            name: "resize",
            rawName: "v-resize",
            value: _vm.onResize,
            expression: "onResize"
          }
        ],
        staticClass: "elevation-1 secondarybackground striped-table",
        attrs: {
          dense: "",
          loading: _vm.loading,
          "fixed-header": "",
          "disable-pagination": "",
          "disable-sort": "",
          height: _vm.height,
          "hide-default-footer": "",
          headers: _vm.headers,
          items: _vm.data,
          "no-data-text": _vm.error
            ? "Une erreur est survenue lors de la récupération des données."
            : "Aucune intervention répondant aux critères"
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex justify-end" },
                  [
                    _c("custom-page-selector", {
                      staticClass: "pa-2",
                      attrs: { namespace: _vm.namespace }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item.reference",
            fn: function({ item }) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(item.reference) +
                    " - " +
                    _vm._s(item.reference_num) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "item.event_datetime",
            fn: function({ item }) {
              return [
                item.customer_type_name
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function({ on }) {
                                return [
                                  _c("div", _vm._g({}, on), [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm._f("displaySchedule")(item)
                                        ) +
                                        "\n            "
                                    ),
                                    item.duration
                                      ? _c("span", [
                                          _vm._v(
                                            "(" + _vm._s(item.duration) + ")"
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.customer_type_name) +
                              "\n          "
                          ),
                          item.customer_phone
                            ? _c("span", [
                                _vm._v("(" + _vm._s(item.customer_phone) + ")")
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  : _c("div", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("displaySchedule")(item)) +
                          "\n        "
                      ),
                      item.duration
                        ? _c("span", [
                            _vm._v("(" + _vm._s(item.duration) + ")")
                          ])
                        : _vm._e()
                    ])
              ]
            }
          },
          {
            key: "item.technician_fullname",
            fn: function({ item }) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(item.technician_fullname) +
                    " - " +
                    _vm._s(item.technician_phone) +
                    "\n    "
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }